import * as React from "react";

export default class QNShortAnswers extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            dodoso:[]
        }

        this.updateAt = this.updateAt.bind(this)
    }

    componentDidMount() {
        this.setState({
            dodoso:this.props.dodoso
        })
    }

    updateAt(d){
        console.log(d)
        console.log(d.table_name)
    }
    render() {
        return(<div style={{width:'100%',float:'left'}}>
            {this.state.dodoso.map((d,i)=>{
                                    return(<div key={i} style={{paddingLeft:'16px',float:'left',width:'100%'}}>
                                        <div className={'qn-header'} style={{float:'left',width:'100%'}}>
                                            <span className={'fa fa-question-circle'}/>{d.hint}
                                        </div>
                                        <div style={{border:'1px solid #888',width:'100%',float:'left',padding:'8px'}}>
                                            {d.questionnaire.map((q,j)=>{
                                                return(<div key={j} style={{width:'100%',float:'left'}}>
                                                    <div style={{width:'30%',float:'left'}}>
                                                        <b>{q.field}</b>
                                                    </div>
                                                    <div style={{width:'80%',float:'right'}}>
                                                        <textarea style={{width:'100%'}}/>
                                                    </div>

                                                </div>)
                                            })}
                                            <button style={{marginBottom:'16px',float:'right'}} className={'ubtn-info'}>Download</button>
                                            <button style={{marginBottom:'16px',float:'right',marginRight:'2px'}}
                                                    onClick={()=>this.updateAt(d)} className={'ubtn-success'}>Update</button>
                                        </div>
                                    </div>)
                                })}
        </div>)
    }
}